import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getMachineBrigades: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].GET_BRIGADES,
	},
	createMachineBrigade: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].CREATE_BRIGADE,
	},
	getMachineBrigade: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].GET_BRIGADE,
	},
	patchMachineBrigade: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].PATCH_BRIGADE,
	},
	putMachineBrigade: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].PUT_BRIGADE,
	},
	deleteMachineBrigade: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.MACHINE_BRIGADE].DELETE_BRIGADE,
	},
}